<template>
    <div>
        <label>
            Languages
        </label>

        <div class="form-group">
            <div
                v-for="(name, index) in rows"
                :key="index"
                class="form-check form-check-inline"
            >
                <input
                    :id="`language-checkbox-${index}`"
                    type="checkbox"
                    :checked="(valuesSelected.indexOf(parseInt(index)) !== -1)"
                    :value="index"
                    class="form-check-input"
                    @change="handleInput($event)"
                />

                <label
                    class="form-check-label"
                    :for="`language-checkbox-${index}`"
                >
                    {{ name }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  props: {
    languagesSelected: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      rows: [],
      valuesSelected: this.languagesSelected,
    };
  },

  mounted() {
    axios({
      method: "get",
      url: "/admin/api/languages-options",
    })
      .then((response) => {
        this.rows = response.data;
      });
  },

  methods: {
    handleInput(event) {
      if (event.target.checked) {
        // add to array
        this.valuesSelected.push(parseInt(event.target.value));
      } else {
        // remove from array
        this.valuesSelected = this.valuesSelected.filter((e) => e !== parseInt(event.target.value));
      }

      this.$emit("update:languages-selected", this.valuesSelected);
    },
  },
};
</script>
